import { useRef } from "react"
import { useFrame } from "@react-three/fiber"
import * as THREE from "three"

interface SealingRingProps {
    position: [number, number, number]
    /** Cuánto va del 3s — 0 a 1. */
    progress: number
    color?: string
}

// Anillo dorado de carga concéntrica que rodea al avatar durante los 3s
// del sealing. La barra crece de 0% a 100%; al completarse se desvanece.
//
// 6 segmentos (hexagonal) consistente con el sello geométrico de RSV.
export function SealingRing({
    position,
    progress,
    color = "#D4AF37",
}: SealingRingProps) {
    const filledRef = useRef<THREE.Mesh>(null)
    const haloRef = useRef<THREE.Mesh>(null)
    const innerRef = useRef<THREE.Mesh>(null)

    useFrame((state, dt) => {
        const t = state.clock.elapsedTime
        if (haloRef.current) haloRef.current.rotation.z += dt * 0.6
        if (innerRef.current) innerRef.current.rotation.z -= dt * 0.4
        if (filledRef.current) {
            const mat = filledRef.current.material as THREE.MeshBasicMaterial
            mat.opacity = 0.6 + Math.sin(t * 4) * 0.15
        }
    })

    const filledGeom = (
        <ringGeometry
            args={[1.05, 1.2, 64, 1, 0, Math.max(0.001, progress * Math.PI * 2)]}
        />
    )

    return (
        <group position={[position[0], 0.06, position[2]]}>
            {/* Pista vacía hexagonal */}
            <mesh ref={haloRef} rotation={[-Math.PI / 2, 0, 0]}>
                <ringGeometry args={[1.0, 1.22, 6]} />
                <meshBasicMaterial
                    color={color}
                    transparent
                    opacity={0.25}
                    side={THREE.DoubleSide}
                />
            </mesh>
            {/* Sector que se llena con el progreso */}
            <mesh ref={filledRef} rotation={[-Math.PI / 2, 0, 0]}>
                {filledGeom}
                <meshBasicMaterial
                    color={color}
                    transparent
                    opacity={0.85}
                    side={THREE.DoubleSide}
                />
            </mesh>
            {/* Anillo interior fino contrarrotando */}
            <mesh ref={innerRef} rotation={[-Math.PI / 2, 0, 0]}>
                <ringGeometry args={[0.92, 0.96, 6]} />
                <meshBasicMaterial
                    color={color}
                    transparent
                    opacity={0.55}
                    side={THREE.DoubleSide}
                />
            </mesh>
        </group>
    )
}
